import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { QuestionPayloadType } from "@/common/types/question";

export async function questionList(
    owner_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `common/question/${owner_id}/list${queryString}`
    );
}

export async function questionGet(
    question_id: string
) {
    return await clientAxios.get(
        `common/question/${question_id}/show`
    );
}

export async function questionAdd(
    owner_id: string,
    payload: QuestionPayloadType
) {
    const formated = {
        ...payload,
        metadata: (typeof payload.metadata === "object")
            ? JSON.stringify(payload.metadata)
            : payload.metadata,
    };

    return await clientAxios.post(
        `common/question/${owner_id}/add`,
        formated
    );
}

export async function questionEdit(
    question_id: string,
    payload: QuestionPayloadType
) {
    const formated = {
        ...payload,
        metadata: JSON.stringify(payload.metadata).toString()
    };

    return await clientAxios.put(
        `common/question/${question_id}/edit`,
        formated
    );
}

export async function questionDel(
    question_id: string
) {
    return await clientAxios.del(
        `common/question/${question_id}/delete`
    );
}